export const PROTECTED_ROUTE_LOADING_MESSAGES = [
  'Checking your session…',
  'Just a moment…',
]

export const TENANT_RESOLUTION_LOADING_MESSAGES = [
  'Finding your workspace…',
  'Almost there…',
]

export const SETUP_PREVIEW_LOADING_MESSAGES = ['Loading your invite…', 'Just a moment…']

export const WORKSPACES_LOADING_MESSAGES = ['Loading your workspaces…', 'Just a moment…']

export const VERIFY_EMAIL_LOADING_MESSAGES = ['Verifying your email…', 'Almost there…']
